var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 34,
    viewBox: "0 0 30 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 11.5H22.5V7.75C22.5 5.76088 21.7098 3.85322 20.3033 2.4467C18.8968 1.04018 16.9891 0.25 15 0.25C13.0109 0.25 11.1032 1.04018 9.6967 2.4467C8.29018 3.85322 7.5 5.76088 7.5 7.75V11.5H2.5C1.83696 11.5 1.20107 11.7634 0.732233 12.2322C0.263392 12.7011 0 13.337 0 14V31.5C0 32.163 0.263392 32.7989 0.732233 33.2678C1.20107 33.7366 1.83696 34 2.5 34H27.5C28.163 34 28.7989 33.7366 29.2678 33.2678C29.7366 32.7989 30 32.163 30 31.5V14C30 13.337 29.7366 12.7011 29.2678 12.2322C28.7989 11.7634 28.163 11.5 27.5 11.5ZM10 7.75C10 6.42392 10.5268 5.15215 11.4645 4.21447C12.4021 3.27678 13.6739 2.75 15 2.75C16.3261 2.75 17.5979 3.27678 18.5355 4.21447C19.4732 5.15215 20 6.42392 20 7.75V11.5H10V7.75ZM27.5 31.5H2.5V14H27.5V31.5Z",
    fill: "#66B927"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lock-icon.3e623f04ca14e3e9fd7e458dd5bd1db5.svg";
export { ForwardRef as ReactComponent };